var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('uploader', _vm._b({}, 'uploader', _vm.config.field, false), [_c('i', { staticClass: "el-icon-upload" }), _vm._v(" "), _c('div', { staticClass: "el-upload__text" }, [_vm._v("\n    将文件拖到此处，或\n    "), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', { staticClass: "el-upload__tip", attrs: { "slot": "tip" }, slot: "tip" }, [_vm._v("\n    只能上传zip文件，自动会加md5值\n  ")])]);
};
var staticRenderFns = [];

export { render, staticRenderFns };